export type ShiftHours = 8 | 12;

export interface BreakRule {
	BreakRuleId: number | null;
	AssetId: number | null;
	AssetName?: string;
	ShiftHours: ShiftHours;
	Label: string;
	OffsetMinutes: number | null;
	DurationMinutes: number | null;
	IsSpell: boolean;
}

export interface BreakLine {
	AssetId: number;
	AssetName: string;
	ParentAssetId: number | null;
	ParentAssetName: string | null;
	DefaultShiftHours: ShiftHours;
}

export interface BreakRulePreset {
	AssetId: number;
	ShiftHours: ShiftHours;
}

export interface BreakRuleImpact {
	Untouched: number;
	Adjusted: number;
}

export const BREAK_RULE_INITIAL_VALUES: BreakRule = {
	BreakRuleId: null,
	AssetId: null,
	ShiftHours: 8,
	Label: "",
	OffsetMinutes: null,
	DurationMinutes: null,
	IsSpell: false,
};
